/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

// Core imports
import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

// Component imports
import BotsTable from '../components/Tables/BotsTable';
import DocumentTitle from '../components/DocumentTitle';

const BotsScreen = () => {
  const { t } = useTranslation();

  return (
    <Fragment>
      <DocumentTitle title={t('Agents')} />
      <BotsTable />
    </Fragment>
  );
};

export default BotsScreen;
